<template lang="html">
    <div class="pgn-wrap">
        <nav class="pgn">
            <ul>
                <li v-if="hasPrev()" >
                    <a href="#" class="pgn__prev" @click.prevent="changePage(prevPage)"></a>
                </li>
                <li v-if="hasFirst()">
                    <a href="#" class="pgn__num" @click.prevent="changePage(1)">1</a>
                </li>
                <li v-if="hasFirst()"><span class="pgn__num dots">...</span></li>
                <li v-for="page in pages">
                    <a href="#" @click.prevent="changePage(page)" :class="{ current: currentPage == page }" class="pgn__num">
                        {{ page }}
                    </a>
                </li>
                <li v-if="hasLast()"><span class="pgn__num dots">...</span></li>
                <li v-if="hasLast()">
                    <a href="#" class="pgn__num" @click.prevent="changePage(totalPages)">{{ totalPages }}</a>
                </li>
                <li v-if="hasNext()">
                    <a href="#" class="pgn__next" @click.prevent="changePage(nextPage)"></a>
                </li>
            </ul>
        </nav>
    </div>
</template>

<script>
// Pagination component

export default {
  components: {
           
  },
  props: {
    total: {
      type: Number,
      default: 0
    },
    perPage: {
      default: 25
    },
    pageRange: {
      type: Number,
      default: 3
    },
    offset: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
              
    };
  },
  computed: {
    currentPage: function(){
      return this.offset/this.perPage + 1;
    },
    pages: function() {
      var pages = [];

      for(var i = this.rangeStart; i <= this.rangeEnd; i++) {
        pages.push(i);
      }

      return pages;
    },
    rangeStart: function() {
      var start = this.currentPage - this.pageRange;

      return (start > 0) ? start : 1;
    },
    rangeEnd: function() {
      var end = this.currentPage + this.pageRange;

      return (end < this.totalPages) ? end : this.totalPages;
    },
    totalPages: function() {
      var pageAmount = Math.ceil(this.total/this.perPage);

      if(this.maxPages != 0 && pageAmount > this.maxPages){
        return this.maxPages;
      } else {
        return pageAmount;
      }
    },
    nextPage: function() {
      return this.currentPage + 1;
    },
    prevPage: function() {
      return this.currentPage - 1;
    }
  },
  methods: {
    hasFirst: function() {
      return this.rangeStart !== 1;
    },
    hasLast: function() {
      return this.rangeEnd < this.totalPages;
    },
    hasPrev: function() {
      return this.currentPage > 1;
    },
    hasNext: function() {
      return this.currentPage < this.totalPages;
    },
    changePage: function(page) {
      let newOffset = (page-1)*this.perPage;
      this.pageInput = page;
      this.$emit('page-changed', newOffset);
    }
  },
  mounted(){
    $(document).on('click', '.pgn a', function(event) {
      event.preventDefault();
    });
  }
};
</script>

